import { z } from 'zod';

import { HELP_ASSISTANT_MAX_MESSAGE_LENGTH } from '@/app/helpArticle/_enums';

const askHelpAssistantSchema = z.object({
  question: z
    .string()
    .trim()
    .min(1, { error: 'Question is required' })
    .max(HELP_ASSISTANT_MAX_MESSAGE_LENGTH, { error: `Question must be ${HELP_ASSISTANT_MAX_MESSAGE_LENGTH} characters or fewer` })
});

export { askHelpAssistantSchema };
